// Copyright (c) 2016 Deere & Company

import NormalClaim from '@deere/cps-it.warranty-model-factory/lib/claim-normal';

export const getUpdatedNormalClaim = (currentClaim, selectedAction) =>
    NormalClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/normal/services/update-normal-claim.js